import { dispatch } from "../store/store";
import {
  getPrescriptionIncomingIdsData,
  getPrescriptionByIncomingIdData,
  getAutomationSummaryData,
  getMedicationData,
  getPostMedicationData,
  getAdditionalEndorsementData,
  setPatientClinicalChecksData,
  getPatientImageData,
  getPrescriptionItemChecksData,
  getPrescriptionChecksData,
  getDrugUomFixValueData,
  setIsCheckNowModel,
  setIsNmsPrescriptionLoading,
  setIsItemchecks,
  setIsSeverityCount,
  setIsMandatory,
  setIsTheraphy,
  setIsEndorse,
  setPrescriptionItemEndorsementsData,
  setIsDispenseArray,
  setClinicalChecksNotes,
  setIsItemReturnDose,
  setIsItemReturnQuantity,
  setIsReturnQuantity,
  setIsReturnDose,
  setIsReturnDispense,
  setIsReturnStartDate,
  setIsReturnStopDate,
  setIsReturnMarking,
  setIsReturnTherapy,
  setIsReturnPreparation,
  setIsReturnArchive,
  setIsReturnColor,
  setIsReturnReport,
  setIsDispense,
  setIsEditable,
  setIsButtonclass,
  setIsNotesModel,
  setIsClinicalHeaderNotesModel,
  setMedicationTimeModel,
  setIsMedicineWarning,
  setIsPatientImage,
  setIsMedicationId,
  setIsParkedData,
  setCCOrderItemToolTipData,
  updateCCOrderItemToolTipData,
  setSelectedBucketTypeData,
  setIsTheraphyModal,
  setTherapyModelContent,
  addpatientInTitanData,
  getTitanPatientSearchData,
  setOpenFindPatientModalData,
  setOpenFindPatientComparisonModalData,
  addEmergencySuppliesData,
  setCCModalOpenData,
  setCCModalLoaderData,
  setPrescriptionItemToolTip,
  updateItemToolTipFlavoursData,
  getKanbanInboxData,
  getKanbanCheckData,
  setIsCCKanbanLoadingData,
  getTitanPatientByPatientIdData,
  setIsCheckedClinicalId,
  updateFlavourQuantity,
  setPatientDataData,
  updateFlavourOrderTrolleyProfileId,
  updateLastOrderedQuantity,
  setKanbanInbox,
  setKanbanChecks,
  setFilterNamevalues,
  getClinicalChecksTagsData,
  setPatientTags,
  setPatientTagsData,
  lockedPrescriptionsData,
  setisHasDispensingWindow,
  setIsAcceptedData,
  setClinicalCheckPositionData,
  setClinicalCheckStatusData,
  updateBucketPositionData,
  updateBucketStatusData,
  deletePatientTagData,
  removePatientTagsData,
  setIsClinicalChecksPatientTags,
  setShowNoPatientInTitanPopupData,
  getPatientHistoryData,
  setIsPatientData,
  setPatientHistory,
  setIsDoseValueData,
  setDoseValueEmptyPrescribedItemIdData,
  setKanbanFiltersData,
  getPatientLastDosageData,
  setIsNewPatientId,
  addTitanAiRaisedConcernDetailsData,
  withdrawTitanAiRaisedConcernData,
} from "../features/clinicalChecksSlice/clinicalChecksSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "clinicalChecksService";

// #region State Setters

export const setSeverityCount = (severityCount) => {
  dispatch(setIsSeverityCount(severityCount));
};

export const setDispenseArray = (dispenseArray) => {
  dispatch(setIsDispenseArray(dispenseArray));
};
export const setMandatory = (isMandatory) => {
  dispatch(setIsMandatory(isMandatory));
};
export const setTheraphy = (isTheraphy) => {
  dispatch(setIsTheraphy(isTheraphy));
};
export const setItemReturnDose = (itemDose) => {
  dispatch(setIsItemReturnDose(itemDose));
};

export const setReturnDispense = (returnDispense) => {
  dispatch(setIsReturnDispense(returnDispense));
};
export const setDispense = (isDispense) => {
  dispatch(setIsDispense(isDispense));
};
export const setEditable = (isEditable) => {
  dispatch(setIsEditable(isEditable));
};
export const setButtonclass = (isButtonClass) => {
  dispatch(setIsButtonclass(isButtonClass));
};
export const setNotes = (notes) => {
  dispatch(setIsNotesModel(notes));
};

export const setMedicationTime = (medicationTime) => {
  dispatch(setMedicationTimeModel(medicationTime));
};
export const setMedicineWarning = (medicineWarnings) => {
  dispatch(setIsMedicineWarning(medicineWarnings));
};

export const setEndorse = (isTheraphy) => {
  dispatch(setIsEndorse(isTheraphy));
};
export const setPrescriptionItemEndorsements = (payload) => {
  dispatch(setPrescriptionItemEndorsementsData(payload));
};
export const setItemChecks = (itemChecks) => {
  dispatch(setIsItemchecks(itemChecks));
};
export const setCurrentClinicalChecksNotes = (itemChecks) => {
  dispatch(setClinicalChecksNotes(itemChecks));
};
export const setCheckNowModel = (checkModel) => {
  dispatch(setIsCheckNowModel(checkModel));
};
export const setPatientImage = (patientImage) => {
  dispatch(setIsPatientImage(patientImage));
};
export const setMedicationId = (isMedication) => {
  dispatch(setIsMedicationId(isMedication));
};
export const setIsParked = (parked) => {
  dispatch(setIsParkedData(parked));
};
export const setSelectedBucketType = (type) => {
  dispatch(setSelectedBucketTypeData(type));
};
export const setTheraphyModal = (isTheraphy) => {
  dispatch(setIsTheraphyModal(isTheraphy));
};
export const setTheraphyModalContent = (therapyContent) => {
  dispatch(setTherapyModelContent(therapyContent));
};
export const setOpenFindPatientModal = (data) => {
  dispatch(setOpenFindPatientModalData(data));
};
export const setOpenFindPatientComparisonModal = (data) => {
  dispatch(setOpenFindPatientComparisonModalData(data));
};
export const setIsCCOpenModal = (isCCModalOpen) => {
  dispatch(setCCModalOpenData(isCCModalOpen));
};
export const setIsCCModalLoader = (isModalLoading) => {
  dispatch(setCCModalLoaderData(isModalLoading));
};
export const setIsPrescriptionItemToolTip = (data) => {
  dispatch(setPrescriptionItemToolTip(data));
};
export const setIsCCKanbanLoading = (data) => {
  dispatch(setIsCCKanbanLoadingData(data));
};
export const setCurrentPatientData = (data) => {
  dispatch(setPatientDataData(data));
};
export const setCheckedClinicalId = (clinicalCheckIds) => {
  dispatch(setIsCheckedClinicalId(clinicalCheckIds));
};
export const setFlavourQuantity = (stockItemId, quantity) => {
  dispatch(updateFlavourQuantity({ stockItemId, quantity }));
};

export const setFlavourOrderTrolleyProfileId = (
  stockItemId,
  orderTrolleyProfileId,
) => {
  dispatch(
    updateFlavourOrderTrolleyProfileId({ stockItemId, orderTrolleyProfileId }),
  );
};

export const setUpdateLastOrderedQuantity = (lastOrderedQuantity) => {
  dispatch(updateLastOrderedQuantity(lastOrderedQuantity));
};
export const setCurrentKanbanInbox = (data) => {
  dispatch(setKanbanInbox(data));
};
export const setCurrentKanbanChecks = (data) => {
  dispatch(setKanbanChecks(data));
};
export const setCurrentPatientHistory = (data) => {
  dispatch(setPatientHistory(data));
};
export const setIsDoseValueEmptyTotal = (doseValue) => {
  dispatch(setIsDoseValueData(doseValue));
};
export const setDoseValueEmptyPrescribedItemId = (data) => {
  dispatch(setDoseValueEmptyPrescribedItemIdData(data));
};
export const setFilterNameData = (data) => {
  dispatch(setFilterNamevalues(data));
};
export const addPatientTag = (tag) => {
  dispatch(setPatientTags(tag));
};
export const setisHasDispensingWindowData = (data) => {
  dispatch(setisHasDispensingWindow(data));
};
export const setisAccepted = (data) => {
  dispatch(setIsAcceptedData(data));
};

export const removePatientTags = (data) => {
  dispatch(removePatientTagsData(data));
};
export const setClinicalChecksPatientTags = (data) => {
  dispatch(setIsClinicalChecksPatientTags(data));
};
export const setShowNoPatientInTitanPopup = (data) => {
  dispatch(setShowNoPatientInTitanPopupData(data));
};
export const setIsPatient = (data) => {
  dispatch(setIsPatientData(data));
};
export const setKanbanFilters = (data) => {
  dispatch(setKanbanFiltersData(data));
};
export const setNewPatientId = (patientId) => {
  dispatch(setIsNewPatientId(patientId));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const getPrescriptionIncomingIds = async (param) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionIncomingIdsData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }

  return result;
};
export const deletePatientTag = async (param) => {
  let result = null;
  try {
    result = await dispatch(deletePatientTagData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }

  return result;
};

export const getPrescriptionByIncomingId = async (param) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionByIncomingIdData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }
  return result;
};

export const getAutomationSummary = async (param) => {
  let result = null;
  try {
    result = await dispatch(getAutomationSummaryData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }
  return result;
};

export const getPatientMedication = async (params) => {
  let result = null;
  try {
    result = await dispatch(getMedicationData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getPostMedication = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPostMedicationData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getAdditionalEndorsement = async (params) => {
  let result = null;
  try {
    result = await dispatch(getAdditionalEndorsementData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getPatientImage = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPatientImageData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const setPatientClinicalChecks = async (params) => {
  let result = null;
  try {
    result = await dispatch(setPatientClinicalChecksData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getPrescriptionItemCheck = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionItemChecksData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getPrescriptionChecks = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionChecksData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const setCCOrderItemToolTip = async (params) => {
  let result = null;
  try {
    result = await dispatch(setCCOrderItemToolTipData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const updateCCOrderItemToolTip = async (params) => {
  let result = null;
  try {
    result = await dispatch(updateCCOrderItemToolTipData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const updateCCOrderItemToolTipFlavours = async (params) => {
  let result = null;
  try {
    result = await dispatch(updateItemToolTipFlavoursData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const updateBucketPosition = async (params) => {
  let result = null;
  try {
    result = await dispatch(updateBucketPositionData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const updateBucketStatus = async (params) => {
  let result = null;
  try {
    result = await dispatch(updateBucketStatusData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const addpatientInTitan = async (params) => {
  let result = null;
  try {
    result = await dispatch(addpatientInTitanData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getDrugUomFixValue = async (param) => {
  let result = null;
  try {
    result = await dispatch(getDrugUomFixValueData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }

  return result;
};

export const getTitanPatientSearchItems = async (param) => {
  let result = null;
  try {
    result = await dispatch(getTitanPatientSearchData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }
};

export const addEmergencySupplies = async (param) => {
  let result = null;
  try {
    result = await dispatch(addEmergencySuppliesData(param)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }

  return result;
};

export const getKanbanInbox = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getKanbanInboxData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};
export const getKanbanCheck = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getKanbanCheckData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};
export const getTitanPatientByPatientId = async (params) => {
  let result = [];
  try {
    result = await dispatch(getTitanPatientByPatientIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = [];
  }
  return result;
};

export const getClinicalChecksTags = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getClinicalChecksTagsData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const setPatientTag = async (params) => {
  let result = null;
  try {
    result = await dispatch(setPatientTagsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const lockedPrescriptions = async (params) => {
  let result = null;
  try {
    result = await dispatch(lockedPrescriptionsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const getPatientHistory = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPatientHistoryData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const getPatientLastDosage = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPatientLastDosageData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const addTitanAiRaisedConcernDetails = async (params) => {
  let result = null;
  try {
    result = await dispatch(addTitanAiRaisedConcernDetailsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const withdrawTitanAiRaisedConcern = async (params) => {
  let result = null;
  try {
    result = await dispatch(withdrawTitanAiRaisedConcernData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

// #endregion
